<script setup lang="ts">
import { ContestContent, SelectionPile } from '@assemblyvoting/js-client/dist/lib/av_client/types';

const props = defineProps<{
  contest: ContestContent,
  selectionPile: SelectionPile,
  editUrl: string,
}>();

function editSelection() {
  window.location.assign(props.editUrl)
}
</script>

<template>
  <AVPileSummary
    :contest="contest"
    :selectionPile="selectionPile"
    :total-piles="1"
    :active-state="'ballot'"
    @edit-current-selection="editSelection"
  />
</template>

<style scoped>

</style>